import { PlantExtIdsRequestModel } from '../models';

export class PlantExternalIDsLoad {
  public static readonly type = '[Plant External IDs] Load';
  constructor(public payload: PlantExtIdsRequestModel) {}
}

export class PlantExternalIDsInitialState {
  public static readonly type = '[Plant External IDs] Set Initial State';
}
